import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import cn from 'classnames'

import styles from './styles.scss'

const Body1 = props => (
  <span class={cn(props.theme.body1)} styleName='body1'>
    { props.children }
  </span>
)

Body1.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.shape({
    body1: PropTypes.string
  })
}

Body1.defaultProps = {
  theme: {},
}
export default CSSModules(styles, Body1)
